import React from 'react'
import Button from '@material-ui/core/Button'
import styled from 'styled-components'

export enum ButtonThemeType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}
interface ButtonProps {
  className?: string
  handleClick?: () => void
  startIcon?: React.FC<React.SVGProps<SVGSVGElement>>
  testId?: string
  width?: number | string
  height?: number
  style?: React.CSSProperties
  theme?: ButtonThemeType
}

interface ButtonThemeConfigType {
  [key: string]: {
    [key: string]: string
  }
}

const BUTTON_THEME_CONFIG: ButtonThemeConfigType = {
  PRIMARY: {
    border: 'none',
    color: '#FFFFFF',
    default: '#c313a7',
    hover: '#c933b0',
    hoverBorder: 'none',
    focus: '#c933b0',
    focusBorder: '0.8px dashed #FFFFFF',
    pressed: '#ffffff',
    pressedColor: '#C313A7',
    pressedBorder: '2px solid #C313A7',
    disabled: '#CCCCCB',
    disabledColor: '#555555',
    disabledBorder: 'none',
  },
  SECONDARY: {
    border: '2px solid #C313A7',
    color: '#C313A7',
    default: '#ffffff',
    hover: '#ffffff',
    hoverBorder: '2px solid #C933B0',
    focus: '#FFFFFF',
    focusBorder: '0.769231px dashed #C933B0',
    pressed: '#C313A7',
    pressedColor: '#FFFFFF',
    pressedBorder: 'none',
    disabled: '#ffffff',
    disabledColor: '#777777',
    disabledBorder: '2px solid #CCCCCC',
  },
}

const CustomizeButton = styled(Button)`
  background-color: ${(props) => BUTTON_THEME_CONFIG[props.theme].default};
  color: ${(props) => BUTTON_THEME_CONFIG[props.theme].color};
  border: ${(props) => BUTTON_THEME_CONFIG[props.theme].border};
  font-size: 16px;
  text-transform: none;
  line-height: 20px;
  box-shadow: none;
  font-family: Quicksand;
  &:hover {
    border: ${(props) => BUTTON_THEME_CONFIG[props.theme].hoverBorder};
    background-color: ${(props) => BUTTON_THEME_CONFIG[props.theme].hover};
  }
  &:disabled {
    color: ${(props) => BUTTON_THEME_CONFIG[props.theme].disabledColor};
    background-color: ${(props) => BUTTON_THEME_CONFIG[props.theme].disabled};
    border: ${(props) => BUTTON_THEME_CONFIG[props.theme].disabledBorder};
    svg {
      path {
        fill: ${(props) => BUTTON_THEME_CONFIG[props.theme].disabledColor};
      }
    }
  }
  &:active {
    background-color: ${(props) => BUTTON_THEME_CONFIG[props.theme].pressed};
    color: ${(props) => BUTTON_THEME_CONFIG[props.theme].pressedColor};
    border: ${(props) => BUTTON_THEME_CONFIG[props.theme].pressedBorder};
    box-shadow: 0px 8px 12px rgba(0, 0, 0, 0.12);
    border-radius: 4px;

    svg {
      path {
        fill: ${(props) => BUTTON_THEME_CONFIG[props.theme].pressedColor};
      }
    }
  }
`

const StyledButton: React.FC<ButtonProps> = ({
  children,
  className,
  handleClick,
  height = 48,
  startIcon: Icon,
  style,
  testId,
  width = 148,
  theme = ButtonThemeType.PRIMARY,
}) => {
  return (
    <CustomizeButton
      variant="contained"
      onClick={handleClick}
      startIcon={Icon ? <Icon /> : null}
      style={{ width, height, ...style }}
      data-testid={testId}
      className={className}
      theme={theme}
    >
      {children}
    </CustomizeButton>
  )
}

export default StyledButton
